export default __webpack_public_path__ + "images/e13420e1e247dc19c8b6894b34d394ed-Loading.gif";